


<template>
<div class="tools-pullout pullout-panel">
  <div class="bkg"></div>

  <div class="help-list">


    <div class="help-scroll">
      <div v-if="!detailPanel">
        <img  class="w-full" src="/img/screens/pullout-post-job.png?v=10122022" />
        <div class="links">

          <div class="company-name" style="top: 71%; left: 7.5%;">{{ companyName }}</div>

          <screen-link left="90%" top="1%" width="8%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
          <screen-link left="5.5%" top="28%" width="88%" height="5%" data-tgt="job-details" dot-class="dot-left-center" data-is-overlay="true" @click.native="showDetails"></screen-link>


        </div>
      </div>
      <div v-if="detailPanel === 'job-details'">
        <img  class="w-full" src="/img/screens/pullout-post-job-details.png?v=10122022" />
        <div class="links">
          <div class="company-name" style="top: 71%; left: 7.5%;">{{ companyName }}</div>
          <screen-link left="90%" top="1%" width="8%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>
          <screen-link left="78%" top="9%" width="19%" height="5%" data-tgt="confirmation" dot-class="dot-left-center" data-is-overlay="true" @click.native="showDetails"></screen-link>



        </div>
      </div>
      <div v-if="detailPanel === 'confirmation'">
        <img  class="w-full" src="/img/screens/pullout-post-job-confirmation.png?v=10122022" />
        <div class="links">
          <screen-link left="90%" top="1%" width="8%" height="5%" data-tgt="profile" dot-class="dot-bottom-center" data-is-overlay="true" @click.native="$emit('close')"></screen-link>

        </div>
      </div>
    </div>


  </div>



</div>
</template>

<script>
import ScreenLink from "@/components/ScreenLink";
export default {
    name: "post-job-pullout",
  components: {ScreenLink},
  props: {},
    data: function(){
        return {
          detailPanel: null
        }
        },
    mounted() {
      if(this.$route.query.level !== undefined){
        this.detailPanel = this.$route.query.level;
      }
    },

    watch: {
      $route: function(next){
        if(next.query.level !== undefined){
          this.detailPanel = next.query.level;
        }
      }
    },

    methods: {
      showDetails: function(e){
          this.detailPanel = e.target.dataset.tgt;
let query = {...this.$route.query};
          query.level=e.target.dataset.tgt;
          this.$router.replace({ name: this.$route.name, params: this.$route.params, query: query });
      },

      onLinkClick: function(e){
        console.log(e);
        this.$emit('link', e);
      },
      showExternalPage: function(e){
        this.$emit("external", e)
      }

    },
    computed: {
        companyName: function(){


          if(this.$store.state.company === 'pro'){
            return "Polarson Inc Sales"
          }else{
            return "Acme Inc Sample"
          }
        }
    }
}
</script>

<style scoped>


.tools-pullout {
  width: 100%;
  position: absolute;
  top: 0;
  height: 100%;


}

.tools-pullout .bkg {
  position: absolute;
  width: 100%;
  height: 100%;
  right: 0;
  background-color: black;
  opacity: 0.4;
}

.tools-pullout img {
  display: block;
}

.tools-pullout bkg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: black;
  opacity: 0.4;

}

.help-list {

  position: absolute;
  width: calc((600/1580) * 100% + 15px);
  top: calc((60/920) * 100%);
  bottom: 0;

  right: 0;
  display: flex;
  flex-direction: column;

}



.help-scroll {
  position: relative;

  overflow-y: scroll;
  height: 100%;
}

.help-scroll .overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  right: 0;
}

.w-full {
  width: 100%;
}

.links {

}

.company-name {
  position: absolute;
  font-size: 14px;
  color: black;
  width: 80%;
 background: white;
  padding: 0.2em;
}

</style>
